var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11950",
    "data-name": "Group 11950",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.069,
    height: 18,
    viewBox: "0 0 19.069 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 19.069,
    height: 18,
    fill: "#6676aa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M.012,14.039a3.676,3.676,0,0,1,1.165-2.814Q5.492,6.906,9.811,2.592A.338.338,0,0,0,9.892,2.2,1.7,1.7,0,0,1,11.626,0a1.632,1.632,0,0,1,1.085.478c1.589,1.59,3.189,3.17,4.762,4.775a1.678,1.678,0,0,1-.8,2.817,4.215,4.215,0,0,1-.934-.017.551.551,0,0,0-.353.09C12.488,11.03,9.6,13.929,6.7,16.809a3.747,3.747,0,0,1-4.039.965A3.8,3.8,0,0,1,.017,14.632a3.385,3.385,0,0,1,0-.593M12.735,9.173l-.05-.09c-.066,0-.132-.01-.2-.01-2.425,0-4.851,0-7.276.008a.7.7,0,0,0-.428.2c-.911.893-1.812,1.8-2.712,2.7A2.731,2.731,0,0,0,1.193,14.5a2.626,2.626,0,0,0,1.895,2.182A2.577,2.577,0,0,0,5.8,16.048c1.764-1.735,3.5-3.495,5.256-5.24.553-.551,1.118-1.09,1.677-1.634M14.6,7.247,10.754,3.378,6.243,7.892H6.6c2.169,0,4.339-.023,6.507.015a1.552,1.552,0,0,0,1.455-.614c.011-.016.024-.031.036-.046M10.916,1.7a5.267,5.267,0,0,0,.41.549c.847.86,1.7,1.712,2.558,2.565q.977.976,1.956,1.949a.5.5,0,0,0,.556.174.537.537,0,0,0,.152-.95q-1.448-1.45-2.9-2.9c-.574-.574-1.153-1.143-1.725-1.719a.5.5,0,0,0-.62-.125c-.15.083-.241.273-.392.456",
    transform: "translate(0 0)",
    fill: "#6676aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M266.406,160.469a1.722,1.722,0,0,1-1.062,1.591,1.683,1.683,0,0,1-1.863-.356,1.625,1.625,0,0,1-.355-1.881c.319-.644.693-1.264,1.074-1.875a.553.553,0,0,1,.946-.023c.39.617.753,1.251,1.1,1.894a2.655,2.655,0,0,1,.161.65m-1.719-1.045c-.187.329-.354.584-.481.858a.485.485,0,0,0,.139.614.464.464,0,0,0,.624.026.664.664,0,0,0,.225-.518,6.026,6.026,0,0,0-.507-.98",
    transform: "translate(-247.337 -148.3)",
    fill: "#6676aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M74.93,184.571c-.706.569-.932.63-1.212.335s-.2-.523.409-1.268a2.43,2.43,0,0,1-.375-.269.591.591,0,0,1-.016-.871.572.572,0,0,1,.844.046c.107.1.2.223.31.356.161-.154.282-.279.414-.393a.571.571,0,0,1,.825.007.606.606,0,0,1-.024.852c-.11.112-.234.209-.29.258a8.534,8.534,0,0,1,.464.9.446.446,0,0,1-.145.365c-.547.49-.855-.031-1.2-.321",
    transform: "translate(-69.181 -171.498)",
    fill: "#6676aa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.379b09ad7e1ace32c04f616790247735.svg";
export { ForwardRef as ReactComponent };